import { useNavigate } from "react-router-dom";
import { DysonSphere } from "@/components/ui/DysonSphere";
import { Icon } from "./LandingIcons";

export function FinalCTA() {
  const navigate = useNavigate();

  return (
    <section className="final">
      <div className="container" style={{ position: "relative" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 32,
          }}
        >
          <DysonSphere size={200} mode="idle" />
        </div>
        <h2>Ready to meet your AI?</h2>
        <p>
          Free forever for individuals. No credit card. Voice demo loads in
          under three seconds.
        </p>
        <div className="final__cta">
          <button
            className="btn btn--accent btn--lg"
            onClick={() => navigate("/sign-in")}
          >
            <Icon name="mic" size={16} /> Start the demo
          </button>
          <a href="#docs" className="btn btn--ghost btn--lg">
            Read the docs
          </a>
        </div>
        <div
          style={{
            marginTop: 28,
            fontSize: 12,
            color: "var(--fg-faint)",
          }}
          className="mono"
        >
          $ npx create-omni-skill@latest
        </div>
      </div>
    </section>
  );
}
